module.exports = _.isUndefined;